import type { MenuProps } from 'antd';
import { WorkMode } from './workMode';

export const getHomePath = (workMode: WorkMode) =>
  workMode === WorkMode.ADMIN ? '/tenant/admin/dashboard' : '/tenant/dashboard';

/**
 * 确保侧边栏始终有一个直接返回当前工作模式首页的入口。
 * 后端菜单已包含首页时保持原顺序，避免重复显示。
 */
export const ensureHomeMenuItem = (
  items: MenuProps['items'],
  workMode: WorkMode,
  homeItem: NonNullable<MenuProps['items']>[number],
): MenuProps['items'] => {
  const list = items ?? [];
  const homePath = getHomePath(workMode);
  const hasHome = list.some((item) => item && 'key' in item && item.key === homePath);

  return hasHome ? list : [homeItem, ...list];
};
